import { useAuthStore } from '~/stores/authStore';
import { authorizationApi } from '@/composable/BaseApi'
import { isBlank } from "~/composable/util";
import * as _ from 'lodash';
import { isEmpty } from 'lodash';

export default defineNuxtRouteMiddleware(async (to, from) => {
  if(useNuxtApp().$axios == null) {
    return;
  }
  if (process.env.NODE_ENV === "pub") {
    // pub 으로 기동 시 권한 체크 all skip
    return;
  }

  const { hasRole }  = useAuthStore();
  const { me, isInitializeCompleted } = storeToRefs(useAuthStore());


  if (!isInitializeCompleted.value) {
    await authorizationApi();
  }

  const role:string = to.meta.role as unknown as string;
  
  const unAuthenticated:boolean = to.meta.unAuthenticated as unknown as boolean;
  if (unAuthenticated) {
    const checkAuthenticated = () => {
      if(!_.isEmpty(me.value)) {
        return navigateTo('/');    
      }
    }
    return checkAuthenticated();    
  }

  const isAuthenticated:boolean = to.meta.isAuthenticated as unknown as boolean;
  if (isAuthenticated) {
    const checkAuthenticated = () => {
      if(_.isEmpty(me.value)) {
        return navigateTo('/login');    
      }
    }
    return checkAuthenticated();
  }  
  // if (isAuthenticated) {
  //   const checkAuthenticated = () => {
  //     if(_.isEmpty(me.value)) {
  //       return navigateTo('/login');    
  //     }
  //   }
  //   return checkAuthenticated();
  // } else 
  if(!isBlank(role)) {
    const checkRole = (role: string) => {
      //page에 role이 설정되어 있으면, 접속자의 role을 확인
      if(!hasRole(role)) {
        return navigateTo('/login');   
        // return navigateTo('/');
        // return abortNavigation(); // abort navigation
      }
    }
    console.log(' role : ', role);
    return checkRole(role);
  }
})
